import { useMemo } from "react";
import { useColorScheme, useTheme } from "@mui/material";
import { RUN_STATUSES } from "src/business-components/RunsStatusBars/RunsStatusBars.constants";
import { getStatusStyles } from "src/business-utils/statusColors";
import type { RunStatus } from "src/queries/pipelines/pipelineRuns.types";

const STATUSES_NEEDING_BOX_SIZING = [
  RUN_STATUSES.COMPLETED_WITH_RETRIES,
  RUN_STATUSES.WITH_RETRIES,
  RUN_STATUSES.COMPLETED_WITH_ERRORS,
  RUN_STATUSES.FAILED_WITH_ERRORS,
] as const;

export const useStatusChipStyle = (status: RunStatus) => {
  const theme = useTheme();
  const { colorScheme } = useColorScheme();

  return useMemo(() => {
    if (!status) {
      return {};
    }

    const palette = theme.vars?.palette || theme.palette;
    const styles = getStatusStyles(status, palette as any, colorScheme);

    // Add boxSizing for retry/error variants
    const needsBoxSizing = STATUSES_NEEDING_BOX_SIZING.includes(
      status.toLowerCase() as RunStatus
    );

    if (needsBoxSizing && Object.keys(styles).length > 0) {
      return {
        ...styles,
        boxSizing: "border-box",
      };
    }

    return styles;
  }, [status, theme, colorScheme]);
};
